// Adds n days starting from the next day
// Example:
// addDays('2024-03-01T13:44Z', 3)
// move to the next day
// 2024-03-02T00:00:00Z
// add 3 days
// 2024-03-05T00:00:00Z
export function addDaysFromNextDay(date: Date, daysToAdd: number) {
  const newDate = new Date(date); // Create a new date to avoid mutating the input
  // Move to the next day's midnight in its timezone
  newDate.setUTCDate(newDate.getUTCDate() + 1); // Move one day forward
  newDate.setUTCHours(0, 0, 0, 0); // Reset to 00:00:00.000 in UTC

  // Add the extra days
  newDate.setUTCDate(newDate.getUTCDate() + daysToAdd);

  return newDate;
}
export function addDays(date: Date, daysToAdd: number) {
  const newDate = new Date(date);
  newDate.setUTCHours(0, 0, 0, 0);
  newDate.setUTCDate(newDate.getUTCDate() + daysToAdd);

  return newDate;
}

// Parses an ISO string to Date
// Example:
// parseISO('2024-03-01T13:44Z') -> Date
export function parseISO(dateString: string): Date {
  return new Date(dateString);
}

export function getDaysDifference(currentDate: Date, newDate: Date): number {
  // set the time to end of user selected day
  newDate.setHours(23, 59, 0, 0);

  const msPerDay = 1000 * 60 * 60 * 24;
  const timeDifference = newDate.getTime() - currentDate.getTime();

  const days = Math.round(timeDifference / msPerDay);

  return days > 0 ? days : 0;
}

//Get Current Year
export function getCurrentUTCYear(): number {
  return new Date().getUTCFullYear();
}
